import { FactoryContext } from '@sqior/react/factory';
import { ListHeaderType, ListViewInfosType } from '@sqior/viewmodels/visual';
import StdDashboard from './std-dashboard/std-dashboard';
import ListHeaderView from './list-header-view/list-header-view';

export function UIVisualPlugin(context: FactoryContext) {
  context.factory.add(ListViewInfosType, StdDashboard);
  context.factory.add(ListHeaderType, ListHeaderView);
}
